import { AbstractControl, ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";
import { AppUtils } from "@app/shared/util/app.utils";


@Component({
    selector: "app-input",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputComponent,
            multi: true
        }
    ],
    styleUrls: ['./input.component.scss'],
    templateUrl: './input.component.html'
})

export class InputComponent implements ControlValueAccessor {
    @Input() placeholder = '';
    @Input() isDisabled = false;
    @Input() isReadonly = false;
    @Input() label = '';
    @Input() formControl: AbstractControl | UntypedFormControl | any;
    @Input() showErrors = false;
    @Input() mask = 'separator.2';
    @Input() thousandSeparator = ',';
    @Input() labelAlign: 'top' | 'left' | 'floating' = 'top';
    @Input() type: 'text' | 'password' | 'email' | 'number' = 'text';
    @Input() tooltipText = '';
    @HostBinding('class.m2') @Input() m2 = false;

    @Output() inputChange = new EventEmitter<any>();
    @Output() onBlurred = new EventEmitter<any>();

    @Input() allowNegative = false;
    @Input() maxLength = 10;
    @Input() id = AppUtils.generateUUID();

    _value: any = '';

    onChangeCallback: (_: any) => {};

    onTouchedCallback: (_: any) => {};

    @HostBinding('class') get labelAlignmentClass(): string {

        if (this.labelAlign === 'left') {
            return 'label-left';
        } else if (this.labelAlign === 'top') {
            return 'label-top';
        } else {
            return 'label-float'
        }
    }

    constructor() {
    }

    get leftLabel() {
        return this.label && this.labelAlign === 'left';
    }

    get topLabel() {
        return this.label && this.labelAlign === 'top';
    }

    get floatLabel() {
        return this.label && this.labelAlign === 'floating';
    }

    get hasError() {
        return this.formControl && this.formControl.errors && this.showErrors;
    }

    get value() {
        return this._value;
    }

    set value(value) {
        if (this.type === 'number') {
            this._value = parseInt(value, 0);
        } else {
            this._value = value;
        }

        if (this.onChangeCallback) {
            this.onChangeCallback(this._value);
        }

        this.inputChange.emit(this._value);
    }

    get determinePlaceholder() {
        if (this.floatLabel) {
            return '';
        } else {
            return this.placeholder;
        }
    }

    writeValue(value) {
        this._value = value;
    }

    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }

    onBlur() {
        this.onBlurred.emit();
    }

    get isNumber() {
        return this.type === 'number';
    }

    get isText() {
        return this.type === 'text';
    }

}
